// extracted by mini-css-extract-plugin
export var chip = "_4h-0";
export var filterDropdown = "_4h-5";
export var filterItem = "_4h-6";
export var icon = "_4h-1";
export var removeButton = "_4h-3";
export var removeIcon = "_4h-4";
export var separator = "_4h-2";